import { render, staticRenderFns } from "./mgr.vue?vue&type=template&id=54b87539"
import script from "./mgr.vue?vue&type=script&lang=js"
export * from "./mgr.vue?vue&type=script&lang=js"
import style0 from "./mgr.vue?vue&type=style&index=0&id=54b87539&prod&lang=less"
import style1 from "./mgr.vue?vue&type=style&index=1&id=54b87539&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports